var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_377_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9526 0.976074C12.0045 0.976235 12.8568 1.82854 12.8569 2.88037H17.6196C18.1453 2.88057 18.5716 3.30683 18.5718 3.83252C18.5718 4.3584 18.1455 4.78545 17.6196 4.78564H2.38037C1.85449 4.7855 1.42822 4.35843 1.42822 3.83252C1.42845 3.3068 1.85463 2.88051 2.38037 2.88037H7.14307C7.14315 1.82849 7.99548 0.976155 9.04736 0.976074H10.9526Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 19.0239C16.667 20.1285 15.7716 21.0239 14.667 21.0239H5.33301C4.22866 21.0237 3.33301 20.1283 3.33301 19.0239V5.78564H16.667V19.0239ZM8.0957 9.59521C7.5698 9.59521 7.14372 10.0215 7.14355 10.5474V16.2622C7.14359 16.7882 7.56972 17.2144 8.0957 17.2144C8.62162 17.2143 9.04782 16.7881 9.04785 16.2622V10.5474C9.04769 10.0215 8.62154 9.5953 8.0957 9.59521ZM11.9053 9.59521C11.3794 9.59521 10.9533 10.0215 10.9531 10.5474V16.2622C10.9532 16.7882 11.3793 17.2144 11.9053 17.2144C12.4312 17.2143 12.8574 16.7882 12.8574 16.2622V10.5474C12.8573 10.0215 12.4311 9.59526 11.9053 9.59521Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_377_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.0479,
    fill: "white",
    transform: "translate(0 0.976074)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.63ff9b653b425b1f78a18d5595ee0b08.svg";
export { ForwardRef as ReactComponent };